/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteRaceClass$Params {
  raceGuid: string;
  raceClassId: number;
}

export function deleteRaceClass(http: HttpClient, rootUrl: string, params: DeleteRaceClass$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteRaceClass.PATH, 'delete');
  if (params) {
    rb.path('raceGuid', params.raceGuid, {"style":"simple"});
    rb.query('raceClassId', params.raceClassId, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteRaceClass.PATH = '/races/{raceGuid}/classes';
